import RichText from "@/components/RichText";
import { CONTAINER } from "../tokens";

// « Ce que nous construisons pour vous » — en-tête sur deux colonnes puis
// grille de cartes numérotées. Le numéro est en chiffres mono verts, comme
// le handoff : aucune icône dans cette maquette.
export default function ServicesSection({ props = {}, blocks = [] }) {
  const cards = (blocks || []).filter((b) => b.type === "service_card" && b.enabled !== false);

  return (
    <section id="services" className={`${CONTAINER} pt-[92px] scroll-mt-24`}>
      <div className="grid md:grid-cols-2 gap-9 items-end mb-10">
        <RichText
          as="h2"
          className="font-display font-semibold text-[clamp(29px,3.5vw,43px)] leading-[1.06] tracking-[-0.03em] text-ink [text-wrap:pretty]"
          html={props.heading}
        />
        <RichText
          as="p"
          preserveParagraphs
          className="text-[16.5px] leading-[1.6] text-ink/[0.6] max-w-[440px]"
          html={props.subheading}
        />
      </div>

      <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(255px,1fr))]">
        {cards.map((b) => (
          <div
            key={b.id}
            data-block-key={b.id}
            className="border-control border-ink/[0.12] rounded-card p-[26px] bg-ink/[0.025] hover:border-ink/30 hover:bg-ink/5 transition-colors duration-150"
          >
            <div className="font-mono text-[12px] text-gold tracking-[0.08em]">{b.props?.number}</div>
            <RichText
              as="h3"
              className="block font-display font-semibold text-[20px] tracking-[-0.015em] mt-3.5 mb-2.5 text-ink"
              html={b.props?.title}
            />
            <p className="text-[15px] leading-[1.6] text-ink/[0.6]">{b.props?.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
